import React, { useEffect, useState } from "react";
import { DialogComponent } from "../../../common/DialogComponent";
import BusinessProtectionPlanUpgradeConfirmation from "../../../Dialogs/protectionPlan/BusinessProtectionPlanUpgradeConfirmation";
import ProtectionPlanSubscriptionChangeDialog from "../../../Dialogs/protectionPlan/ProtectionPlanSubscriptionChangeDialog";
import * as ProtectionPlanActions from "../../../../store/protectionPlanService/business/actions";
import { useDispatch, useSelector } from "react-redux";
import BusinessProtectionPlanUpgradePackage from "../../../Dialogs/protectionPlan/BusinessProtectionPlanUpgradePackage";
import BusinessProtectionPlanUpgradeCompleteDialog from "../../../Dialogs/protectionPlan/BusinessProtectionPlanUpgradeCompleteDialog";
import { ApplicationState } from "../../../../store";
import { IPackage, ISmbLicenseLimit } from "../../../../store/protectionPlanService/business/types";
import ErrorBoundary from "../../../common/ErrorBoundary";
import * as httpClient from "../../../../util/httpClient";
import { GET_ACCOUNT_INFORMATION_LOADER } from "../../../../store/myAccount/types";
import * as services from "../../../../store/service";
import { Notification } from "../../../common/Notification";
import { useTranslation } from "react-i18next";

interface IProps {
    initialDialog: string;
    packageIndex: number;
    onClose: any;
    subscriptionTypeChange: boolean;
    licenseLimit: string;
    packages: any;
    keepPackage: boolean;
}

let billingInfoRequestData: any = null;
let isBillingInfoChanged: boolean = false;

const BusinessProtectionPlanDialogContainer: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));
    const [billingInfoRequest, setBillingInfoRequest] = useState<any>(null);
    const [state, setState] = useState({
        packageIndex: -1,
        billingLabel: "",
        bilingAmount: 0,
        billingText: "",
        licenseLimit: "",
        subscriptionType: "",
        subscriptionCharge: "",
        salesTax: "",
        newCharge: "",
    });
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const [subscriptionChangeDialog, setSubscriptionChangeDialog] = useState(false);
    const [upgradeConfirmationDialog, setUpgradeConfirmationDialog] = useState(false);
    const [upgradeDialog, setUpgradeDialog] = useState(false);
    const [upgradeCompleteDialog, setUpgradeCompleteDoneDialog] = useState(false);
    const [billingInfoChanged, setBillingInfoChanged] = useState(false);
    const [newInitialDialog, setNewInitialDialog] = useState(props.initialDialog);
    const packageList = useSelector((state: ApplicationState) => {
        return state.protectionPlanBusinessState?.protectionPlanData?.smbLicenseLimits?.find((it: ISmbLicenseLimit) => it.key === props.licenseLimit)?.packageList;
    });
    const currentPackage = packageList?.find((pkg) => pkg.IsActive);
    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;
    const isPackageUpgradeDownGrade =
        props.packages && props.packages[props.packageIndex]
            ? props.packages[props.packageIndex].ActionButtonText?.toUpperCase() === "UPGRADE" ||
              props.packages[props.packageIndex].ActionButtonText?.toUpperCase() === "DOWNGRADE"
            : false;
    const { t: tLang } = useTranslation();

    const [twoStepCancellationDialog, setTwoStepCancellationDialog] = useState(false);
    const [showTwoStepCancellationDialog, setShowTwoStepCancellationDialog] = useState(false);

    const handleSubscriptionChangeDialog = (value: string): any => {
        if (value === "show") {
            setSubscriptionChangeDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setSubscriptionChangeDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setSubscriptionChangeDialog(false);
            props.onClose();
        } else if (value === "next") {
            document.body.classList.remove("no_scroll");
            setSubscriptionChangeDialog(false);
        }
    };

    const closeSubscriptionAndShowNextDialog = () => {
        handleSubscriptionChangeDialog("next");
        if (selectedPackage?.PackagId === currentPackage?.PackagId) {
            handlePackageUpgradeDialog("show");
        } else {
            handleUpgradeConfirmationDialog("show");
        }
    };

    const handleUpgradeConfirmationDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeConfirmationDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeConfirmationDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeConfirmationDialog(false);
            props.onClose();
        }
    };

    const closeUpgradeConfirmationDialog = () => {
        setUpgradeConfirmationDialog(false);
        setNewInitialDialog("");
    };

    billingInfoRequestData = (billingInfoRequest && billingInfoRequest.data) || null;

    const setSaveBillingInfo = () => {
        const requestBody = {
            creditCardDetails: billingInfoRequestData && billingInfoRequestData.paymentMethod.selection === "CC" ? billingInfoRequestData.creditCard : null,
            eftDetails: billingInfoRequestData && billingInfoRequestData.paymentMethod.selection === "EFT" ? billingInfoRequestData.eft : null,
            billingAddress: billingInfoRequestData && billingInfoRequestData.billingAddress,
            paymentMode: {
                Selection: billingInfoRequestData && billingInfoRequestData.paymentMethod.selection,
            },
            inAppDetails: null,
        };
        services.saveBillingInfoUpdateTax(requestBody).then((data) => {
            setBillingInfoChanged(false);
            if (data.errors && data.errors.length > 0) {
                Notification({
                    type: "error",
                    title: tLang("manageAccount.protectionPlan.notification.title"),
                    message: data.errors[0],
                    duration: 5,
                });
            }
        });
    };

    isBillingInfoChanged = billingInfoChanged;

    const handlePackageUpgradeDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
            if (isBillingInfoChanged) {
                setSaveBillingInfo();
            }
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
            if (isBillingInfoChanged) {
                setSaveBillingInfo();
            }
            props.onClose();
        } else if (value === "submitted") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
        }
    };

    const closeUpgradeAndOpenCompletionDialog = (
        billingAmount: number,
        billingLabel: string,
        billingText: string,
        subscriptionType: string,
        subscriptionCharge: string,
        salesTax: string,
        newCharge: string
    ) => {
        setState({
            ...state,
            bilingAmount: billingAmount,
            billingLabel: billingLabel,
            billingText: billingText,
            subscriptionType,
            subscriptionCharge,
            salesTax,
            newCharge,
        });
        handlePackageUpgradeDialog("submitted");
        handleUpgradeDoneDialog("show");
    };

    const showPackageUpgrade = (event: any) => {
        closeUpgradeConfirmationDialog();
        if (!twoStepCancellationDialog) {
            handlePackageUpgradeDialog("show");
        } else {
            handleTwoStepCancellationDialog();
        }
    };

    const handleUpgradeDoneDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeCompleteDoneDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeCompleteDoneDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeCompleteDoneDialog(false);
            requestProtectionPlan(true);
            props.onClose();
        }
    };
    const handleTwoStepCancellationDialog = () => {
        setShowTwoStepCancellationDialog(true);
        sessionStorage.setItem("twoStepCancel", "true");
    };

    const loadInitialDialog = () => {
        setState({ ...state, packageIndex: props.packageIndex, licenseLimit: props.licenseLimit });
        if (newInitialDialog === "ProtectionPlanSubscriptionChangeDialog") {
            setSubscriptionChangeDialog(true);
        } else if (newInitialDialog === "BusinessProtectionPlanUpgradeConfirmation") {
            setUpgradeConfirmationDialog(true);
        } else if (newInitialDialog === "BusinessProtectionPlanUpgradePackage") {
            setUpgradeDialog(true);
        } else if (newInitialDialog === "BusinessProtectionPlanTwoStepCancel") {
            setTwoStepCancellationDialog(true);
            setUpgradeConfirmationDialog(true);
        }
    };

    const getAccountInformation = () => {
        httpClient
            .sendRequest("GET", "api/accountInfo/getAccountInformation")
            .then((data) => {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
                if (data && data.hasError === false) {
                    dispatch({
                        type: "GET_ACCOUNT_INFORMATION",
                        _unifiedAccountInfo: data._unifiedAccountInfo,
                    });
                }
            })
            .catch(function (error) {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
            });
    };

    useEffect(() => {
        if (props != null) {
            loadInitialDialog();
        }
    }, [props]);

    useEffect(() => {
        if (accountInfo && accountInfo.country === "") {
            getAccountInformation();
        }
        if (isPackageUpgradeDownGrade || props.keepPackage) {
            showPackageUpgrade("show");
        }
    }, []);

    return (
        <React.Fragment>
            {state.packageIndex !== -1 && (
                <React.Fragment>
                    <ErrorBoundary componentName="Protection Plan Subscription Change Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {subscriptionChangeDialog && (
                            <DialogComponent
                                dialogId="protection-plan-subscription-change-dialog"
                                title={tLang("manageAccount.protectionPlan.subscriptionChangeTitle")}
                                datalayerEvent="Protection Plan - Close subscription type change"
                                closeDialog={() => {
                                    handleSubscriptionChangeDialog("close");
                                }}
                            >
                                <ProtectionPlanSubscriptionChangeDialog
                                    closeDialog={() => {
                                        handleSubscriptionChangeDialog("close");
                                    }}
                                    showNextDialog={closeSubscriptionAndShowNextDialog}
                                    packageIndex={state.packageIndex}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Confirmation Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeConfirmationDialog && (
                            <DialogComponent
                                dialogId="protection-plan-upgrade-confirmation-dialog"
                                title={tLang("manageAccount.protectionPlan.upgradeConfirmationTitle")}
                                datalayerEvent="Protection Plan - Close confirmation"
                                closeDialog={() => {
                                    handleUpgradeConfirmationDialog("close");
                                }}
                            >
                                <BusinessProtectionPlanUpgradeConfirmation
                                    closeDialog={() => {
                                        handleUpgradeConfirmationDialog("close");
                                    }}
                                    showUpgradeDialog={() => {
                                        showPackageUpgrade("show");
                                    }}
                                    packageIndex={state.packageIndex}
                                    licenseLimit={state.licenseLimit}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Package Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeDialog && (
                            <DialogComponent
                                dialogId="protection-plan-package-upgrade-dialog"
                                title={tLang("manageAccount.protectionPlan.packageUpgradeTitle")}
                                datalayerEvent="Protection Plan - Close cart summary"
                                closeDialog={() => {
                                    handlePackageUpgradeDialog("close");
                                }}
                            >
                                <BusinessProtectionPlanUpgradePackage
                                    dialogId="protection-plan-package-upgrade-dialog"
                                    closeDialog={() => {
                                        handlePackageUpgradeDialog("close");
                                    }}
                                    packageIndex={state.packageIndex}
                                    closeUpgradeAndOpenCompletionDialog={closeUpgradeAndOpenCompletionDialog}
                                    subscriptionTypeChange={props.subscriptionTypeChange}
                                    licenseLimit={state.licenseLimit}
                                    setBillingInfoRequest={setBillingInfoRequest}
                                    setBillingInfoChanged={setBillingInfoChanged}
                                    packages={props.packages}
                                    keepPackage={props.keepPackage}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Complete Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeCompleteDialog && (
                            <DialogComponent
                                dialogId="protection-plan-upgrade-done-dialog"
                                title={tLang("manageAccount.protectionPlan.planUpgradeDoneTitle")}
                                datalayerEvent="Protection Plan - Close completion"
                                closeDialog={() => {
                                    handleUpgradeDoneDialog("close");
                                }}
                            >
                                <BusinessProtectionPlanUpgradeCompleteDialog
                                    dialogId="protection-plan-upgrade-done-dialog"
                                    closeDialog={() => {
                                        handleUpgradeDoneDialog("close");
                                    }}
                                    billingLabel={state.billingLabel}
                                    billingAmount={state.bilingAmount}
                                    billingText={state.billingText}
                                    subscriptionType={state.subscriptionType}
                                    subscriptionCharge={state.subscriptionCharge}
                                    salesTax={state.salesTax}
                                    selectedPackage={selectedPackage}
                                    subscriptionTypeChange={props.subscriptionTypeChange}
                                    newCharge={state.newCharge}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>
                    <ErrorBoundary componentName="Protection Plan Upgrade Package Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {showTwoStepCancellationDialog && (
                            <DialogComponent
                                dialogId="protection-plan-upgrade-done-dialog"
                                title={tLang("manageAccount.protectionPlan.planUpgradeDoneTitle")}
                                datalayerEvent="Protection Plan - Close completion"
                                hideCloseButton={true}
                                noEsc={true}
                                closeDialog={() => {}}
                            >
                                <BusinessProtectionPlanUpgradePackage
                                    dialogId="protection-plan-upgrade-done-dialog"
                                    closeDialog={() => {}}
                                    packageIndex={state.packageIndex}
                                    closeUpgradeAndOpenCompletionDialog={closeUpgradeAndOpenCompletionDialog}
                                    subscriptionTypeChange={props.subscriptionTypeChange}
                                    licenseLimit={state.licenseLimit}
                                    setBillingInfoRequest={setBillingInfoRequest}
                                    setBillingInfoChanged={setBillingInfoChanged}
                                    packages={props.packages}
                                    keepPackage={props.keepPackage}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default BusinessProtectionPlanDialogContainer;
